import { SchoolData } from "@nimble/candidate-api/types";

import { PrincipalCardPreset } from "@/app/(discover)/candidate/invites/components/principal-card";
import { ExpressInterestFormContainer } from "@/components/shared/buttons/express-interest-button/express-interest-modal/express-interest-form";
import { Button } from "@/components/ui/button";
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { User } from "@/lib/types/auth";

export function ExpressInterestModalContentView({
  onClose,
  onSubmitSuccess,
  schoolData,
  user,
}: {
  onClose: () => void;
  onSubmitSuccess: () => void;
  schoolData: SchoolData;
  user: User;
}) {
  return (
    <div className="flex flex-col gap-0">
      <DialogHeader className="px-6 pt-6 pb-4 border-b border-border">
        <DialogTitle className="text-sm font-bold text-foreground">
          Express interest
        </DialogTitle>
        <DialogDescription className="text-xs text-ink-subtle mt-1">
          Send a message to the principal at this school
        </DialogDescription>
      </DialogHeader>

      <div className="px-6 py-4 border-b border-line-faint">
        <PrincipalCardPreset schoolData={schoolData} />
      </div>

      <div className="px-6 pt-4 pb-6">
        <ExpressInterestFormContainer
          onSubmitSuccess={onSubmitSuccess}
          onCancel={onClose}
          schoolNcesId={schoolData.nces_id}
          schoolName={schoolData.name}
          user={user}
        />
      </div>
    </div>
  );
}

export function ExpressInterestAlreadySubmittedContentView(props: {
  onClose: () => void;
}) {
  return (
    <div className="space-y-4 p-6">
      <DialogHeader className="text-left space-y-2">
        <DialogTitle className="text-sm font-bold text-foreground">
          Already expressed interest
        </DialogTitle>
        <DialogDescription className="text-xs text-ink-subtle">
          You have already connected with this school or have an ongoing match
          with them.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          onClick={props.onClose}
          className="w-full h-10 shadow-none"
          variant="default"
        >
          Close
        </Button>
      </DialogFooter>
    </div>
  );
}
